import serves from "@/http";
// import * as storage from "../storage";
import * as types from "./mutations-type";
export const ActionCadastro = ({dispatch},payload)=>{
    return serves.desligamentotabelapreco.cadastra(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionLista = ({dispatch},payload)=>{
    return serves.desligamentotabelapreco.lista(payload).then(res => {
        dispatch('ActionSetLista',res)
    }).catch(err => {
        dispatch('ActionSetLista',res)
    })
}
export const ActionDeletar = ({dispatch},payload)=>{
    return serves.desligamentotabelapreco.delete(payload).then(res => {
        console.log(res);
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',res)
    })
}
export const ActionEditar = ({dispatch},payload)=>{
    return serves.desligamentotabelapreco.editar(payload).then(res => {
        dispatch('ActionSetEditar',res)
    }).catch(err => {
        dispatch('ActionSetEditar',err)
    })
}
export const ActionUpdate = ({dispatch},payload)=>{
    return serves.desligamentotabelapreco.update(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionCola = ({dispatch},payload)=>{
    return serves.tabelaprecorublica.cola(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionPesquisa = ({dispatch},payload)=>{
    return serves.desligamentotabelapreco.pesquisa(payload).then(res => {
        dispatch('ActionSetPesquisa',res)
    }).catch(err => {
        dispatch('ActionSetPesquisa',res)
    })
}

export const ActionEventoDeletar = ({dispatch},payload)=>{
    return serves.desligamentotabelapreco.eventodeleta(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',res)
    })
}
export const ActionEventoUpdate = ({dispatch},payload)=>{
    return serves.tabelaprecorublica.eventoupdate(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',res)
    })
}
export const ActionSetLista = ({commit},payload) =>{
    commit(types.SET_LISTA,payload)
}
export const ActionSetMsg = ({commit},payload) =>{
    commit(types.SET_MSG,payload)
}
export const ActionSetEditar = ({commit},payload) =>{
    commit(types.SET_EDITAR,payload)
}
export const ActionSetPesquisa = ({commit},payload) =>{
    commit(types.SET_PESQUISA,payload)
}
export const ActionSetEvento = ({commit},payload) =>{
    commit(types.SET_EVENTO,payload)
}